import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import WithdrawRequestsPage from './WithdrawRequestsPage.vue'

export const withdrawRequestsRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_WITHDRAW_REQUESTS,
    name: 'treasury.withdrawRequests',
    component: WithdrawRequestsPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Withdrawal approvals',
      activeMenu: 'Treasury',
    },
  },
]
